import React from 'react';
import { Box, Typography, Paper, Button, CircularProgress } from '@mui/material';

const StatCard = ({ title, value, icon, color, onGetTotal, loading }) => (
  <Paper variant="outlined" sx={{ p: 3, height: '100%' }}>
    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
      {icon}
      <Typography variant="h6" sx={{ ml: 1 }}>
        {title}
      </Typography>
    </Box>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
      <Typography variant="h4" color={color}>
        {loading ? <CircularProgress size={24} /> : value ?? '-'}
      </Typography>
      <Button 
        variant="outlined" 
        size="small" 
        onClick={onGetTotal}
        disabled={loading}
      >
        {loading ? <CircularProgress size={20} /> : 'Calculate Total'}
      </Button>
    </Box>
  </Paper>
);

export default StatCard; 